export default class WCArchiveSidebar {
    constructor() {
        this.wcSidebar = document.querySelector('.jsWooSidebar');
        this.wcSidebarToggle = document.querySelector('.jsWooSidebarToggle');

        this.events();
    }

    events() {
        if (this.wcSidebar && this.wcSidebarToggle) {
            this.wcSidebarToggle.addEventListener(
                'click',
                this.showSidebar.bind(this),
            );

            this.wcSidebar.addEventListener(
                'click',
                this.handleSidebarClick.bind(this),
            );

            this.wcSidebar.addEventListener(
                'transitionend',
                this.changeBgColor.bind(this),
            );
        }
    }

    showSidebar() {
        this.wcSidebar.classList.add('is-open');
        this.wcSidebarToggle.classList.add('is-open');
    }

    handleSidebarClick(e) {
        const clickedElement = e.target;
        const clickedOnSidebarContent = clickedElement.closest(
            '.jsWooSidebarContent',
        );

        if (clickedOnSidebarContent) return;

        this.closeSidebar();
    }

    closeSidebar() {
        if (
            this.wcSidebar.classList.contains('is-open') &&
            this.wcSidebar.classList.contains('has-bg')
        ) {
            this.wcSidebar.classList.remove('has-bg');
            this.wcSidebar.classList.remove('is-open');
            this.wcSidebarToggle.classList.remove('is-open');
        }
    }

    changeBgColor() {
        if (this.wcSidebar.classList.contains('is-open')) {
            this.wcSidebar.classList.add('has-bg');
        }
    }
}
